import { useMemo } from 'react'
import { useAuthenticatedUser } from '@omnea-app/fe-auth/UserSessionProvider'
import { RfxHttpClient } from '@omnea-app/rfx/rfxHttpClient'

/**
 * Returns a configured instance of the RfxHttpClient, pre-bound with the user's authentication token.
 * Avoids the need to create a client inside the body of each React Query hook.
 *
 * Note: this could be lifted into a provider for reuse.
 */
export const useRfxHttpClient = () => {
  const { getToken } = useAuthenticatedUser()

  return useMemo(() => new RfxHttpClient({ authorization: getToken }), [getToken])
}
